<template>
  <span
    class="lock-button-component-container"
    @click.prevent.stop="click"
  >
    <icon
      name="lock-uui"
      variant="101828"
      class="lock-button-icon"
    />
  </span>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    resource: {
      type: Object,
    },
    source: {
      type: Object,
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    resolvedType() {
      return this.type ?? this.$store.getters['app/pricingType'];
    },
  },
  methods: {
    click() {
      this.$analytics.events.clickedUpsell(this.$store, 'Locked Content', this.resolvedType);
      this.$store.dispatch('ui/toggleUpsellModal', { show: true, source: this.source, resource: this.resource });
    },
  },
};
</script>
<style lang='scss' scoped>
  .lock-button-component-container {
    display: inline !important;
  }

  .lock-button-icon {
    display: inline-block !important;
    min-height: 14px;
    min-width: 10px;
    max-height: 14px;
    max-width: 10px;
  }
</style>
